'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* global FB */


exports.default = configureFacebookAnalitycs;

var _scriptLoader = require('./script-loader.js');

var _scriptLoader2 = _interopRequireDefault(_scriptLoader);

var _defered = require('./defered');

var _defered2 = _interopRequireDefault(_defered);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureFacebookAnalitycs(_ref) {
  var config = _ref.config,
      handlers = _ref.handlers,
      window = _ref.window,
      document = _ref.document;

  var promise = Promise.resolve();

  if (!config.preloaded) {
    var src = 'https://connect.facebook.net/en_US/sdk.js';
    window.fbAsyncInit = function () {
      FB.init({
        appId: config.id,
        xfbml: true,
        version: 'v2.8'
      });
    };

    promise = (0, _scriptLoader2.default)({ src: src, id: 'facebook-jssdk', globalName: 'FB', window: window, document: document });
  }

  var deferred = new _defered2.default();
  deferred.run(function () {
    return (typeof FB === 'undefined' ? 'undefined' : _typeof(FB)) === 'object' && window.fbAsyncInit.hasRun;
  });

  handlers.push(handleEvent);

  return promise;

  function handleEvent(_ref2) {
    var type = _ref2.type,
        id = _ref2.id,
        properties = _ref2.properties,
        userId = _ref2.userId;

    if (type === 'page') {
      return deferred.push(function () {
        FB.AppEvents.logPageView();
      });
    }

    if (type === 'track') {
      return deferred.push(function () {
        FB.AppEvents.logEvent(id, null, properties);
      });
    }

    if (type === 'setUserId' && userId) {
      return deferred.push(function () {
        FB.AppEvents.setUserID(userId);
      });
    }

    return null;
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/auth0-tag-manager/lib/facebook-analytics.js
// module id = 119
// module chunks = 0